import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CitiShopPropsService } from '../../utility/citi-shop-props.service';
import { MktTaggingTransformationService } from 'src/app/core/services';
import { getBrowserNameForTagging } from '../../utility/browser-util';
import { AdaFriendlyNamePipe } from 'src/app/common/pipes/ada-friendly-name.pipe';

@Component({
  selector: 'app-citi-shop-article',
  templateUrl: './citi-shop-article.component.html',
  styleUrls: ['./citi-shop-article.component.scss'],
  standalone: false
})
export class CitiShopArticleComponent {
  @Input() contentArticle: any = '{}';

  constructor(
    public csp: CitiShopPropsService,
    private sanitized: AdaFriendlyNamePipe,
    private _mktTaggingTransformationService: MktTaggingTransformationService
  ){
  }

  onClickArticleCTA(articleTitle, articleCTA ){
    articleTitle = this.sanitized.sanitizePlainText(articleTitle) // Remove HTMl Tags
    const tagObj = {
      'link_name': `${articleTitle}|${articleCTA}`,
      'form_type': getBrowserNameForTagging(),
    }

    this._mktTaggingTransformationService.triggerEventTagging('nonicms_content', '641_a6_citishop_landing_article_CTAClicked', { dynamicContent: tagObj });
  }
}
